import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/common/common.css'

// 引入echarts
// import echarts from 'echarts'
//
// Vue.prototype.$echarts = echarts

// 引入rem
import './utils/layout'

// 引入富文本编辑器vue-quill-editor
import  VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

// 导入axios post、get请求
import {axiosPost,axiosGet} from './http/request.js'
import {httpPost,httpsGet} from './utils/request1.js'

// 挂载post请求
Vue.prototype.axiosPost = axiosPost
Vue.prototype.axiosGet = axiosGet
// Vue.prototype.httpPost = httpPost
// Vue.prototype.httpsGet = httpsGet



Vue.use(VueQuillEditor);

Vue.config.productionTip = false
Vue.use(ElementUI)
// 利用bus总线传值
window.publicVue = new Vue()    // display:{isShow}  // 是否显示
// console.dir(publicVue)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
